import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItem.model';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';

export const TotalPrice = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
}) => {
  const {supportModifiersOnCart} = useControllerProps().cartStore;

  return (
    <div
      className={supportModifiersOnCart ? s.totalPrice : s.totalPriceOld}
      data-hook={CartItemDataHook.TotalPrice}
      data-wix-item-total-price={CartItemDataHook.TotalPrice}>
      {shouldShowCrossedOutPriceOnLineItemLevel && lineItem.crossedOutPrice?.formattedConvertedAmount && (
        <div data-hook={CartItemDataHook.ComparePriceOnLineItem} className={s.comparePrice}>
          {lineItem.crossedOutPriceByQuantity.formattedConvertedAmount}
        </div>
      )}
      <div className={s.totalPriceText}>{lineItem.lineItemPrice.formattedConvertedAmount}</div>
    </div>
  );
};
